[
  {
    "code": "CL-AI",
    "name": "Aisén del General Carlos Ibáñez del Campo"
  },
  {
    "code": "CL-AN",
    "name": "Antofagasta"
  },
  {
    "code": "CL-AR",
    "name": "Araucanía"
  },
  {
    "code": "CL-AP",
    "name": "Arica y Parinacota"
  },
  {
    "code": "CL-AT",
    "name": "Atacama"
  },
  {
    "code": "CL-BI",
    "name": "Bío-Bío"
  },
  {
    "code": "CL-CO",
    "name": "Coquimbo"
  },
  {
    "code": "CL-LI",
    "name": "Libertador General Bernardo O'Higgins"
  },
  {
    "code": "CL-LL",
    "name": "Los Lagos"
  },
  {
    "code": "CL-LR",
    "name": "Los Ríos"
  },
  {
    "code": "CL-MA",
    "name": "Magallanes"
  },
  {
    "code": "CL-ML",
    "name": "Maule"
  },
  {
    "code": "CL-RM",
    "name": "Región Metropolitana de Santiago"
  },
  {
    "code": "CL-TA",
    "name": "Tarapacá"
  },
  {
    "code": "CL-VS",
    "name": "Valparaíso"
  },
  {
    "code": "CL-NB",
    "name": "Ñuble"
  }
]